/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, Input } from '@angular/core';
import { TaskViewVoModel } from '@well/delivery-libs/task-management/domain';
import { SelectItemsModule } from '@well/select-items-shell-api';
import { SharedComponentsModule } from '@well/shared-components';
import { DecimalPipe } from '@angular/common';

@Component({
  selector: 'well-task-card-summary-details',
  templateUrl: './task-card-summary-details.component.html',
  styleUrls: ['./task-card-summary-details.component.scss'],
  standalone: true,
  imports: [SelectItemsModule, SharedComponentsModule, DecimalPipe],
})
export class TaskCardSummaryDetailsComponent {
  @Input() task: TaskViewVoModel | undefined = undefined;
}
